import { FC } from "react";

const CookiesPolicys: FC = () => {
  return (
    <div className="pt-25 pb-15 md:pt-50">
      <p className="text-dark text-4xl leading-tight font-light">
        Slapukų politika
      </p>
      <br />
      <p className="text-dark text-xl leading-tight font-normal">
        TELOMERA ASMENS DUOMENŲ TVARKYMO TAISYKLĖS – SLAPUKŲ POLITIKA
      </p>
      <br />
      <p>
        Klientų asmens duomenų tvarkymo taisyklės (toliau – Taisyklės)
        reglamentuoja klientų asmens duomenų rinkimo, naudojimo ir saugojimo
        principus, nustato klientų asmens duomenų tvarkymo tikslus ir priemones,
        nustato, kas ir kokiais tikslais, gali susipažinti su klientų asmens
        duomenimis.
      </p>
      <br />
      <h4>SĄVOKOS</h4>
      <br />
      <p>
        Atsakingas asmuo – fizinis ar juridinis asmuo pagal paslaugų ar kitą
        sutartį Įmonės paskirtas tvarkyti klientų asmens duomenis;
      </p>
      <br />
      <p>
        Įmonė – Telomera.LT, UAB, 305022637 (Žeimių g. 6B-26, Ginkūnų k.,
        LT-81486 Šiaulių r., +37063988229, info@telomera.lt)
      </p>
      <br />
      <p>
        Kitos šiose Taisyklėse vartojamos sąvokos yra suprantamos taip, kaip jos
        apibrėžtos Lietuvos Respublikos asmens duomenų teisinės apsaugos
        įstatyme ir kituose asmens duomenų tvarkymą reglamentuojančiuose teisės
        aktuose. Pagrindinės sąvokos yra šios:
      </p>
      <br />
      <p>
        Asmens duomenys – bet kuri informacija, susijusi su fiziniu asmeniu –
        duomenų subjektu, kurio tapatybė yra žinoma, arba gali būti tiesiogiai
        ar netiesiogiai nustatyta pasinaudojant tokiais duomenimis kaip asmens
        kodas, vienas arba keli asmeniui būdingi fizinio, fiziologinio,
        psichologinio, ekonominio, kultūrinio ar socialinio pobūdžio požymiai.
      </p>
      <br />
      <p>
        Duomenų tvarkymas – bet kuris su asmens duomenimis atliekamas veiksmas:
        rinkimas, užrašymas, kaupimas, saugojimas, klasifikavimas, grupavimas,
        jungimas, keitimas (papildymas ar taisymas), teikimas, paskelbimas,
        naudojimas, loginės ir (ar) aritmetinės operacijos, paieška, skleidimas,
        naikinimas ar kitoks veiksmas arba veiksmų rinkinys.
      </p>
      <br />
      <p>
        Trečiasis asmuo – juridinis ar fizinis asmuo, išskyrus duomenų subjektą,
        duomenų valdytoją, duomenų tvarkytoją ir asmenis, kurie yra tiesiogiai
        duomenų valdytojo ar duomenų tvarkytojo įgalioti tvarkyti duomenis.
      </p>
      <br />
      <h4>II SKYRIUS</h4>
      <br />
      <h4>DUOMENŲ RINKIMAS, SLAPUKAI</h4>
      <br />
      <p>Mes tvarkome Jūsų Asmens duomenis, gautus tokiais būdais:</p>
      <br />
      <p>Kai Asmens duomenis mums pateikiate Jūs pats;</p>
      <br />
      <p>
        Kai mes patys surenkame Jūsų Asmens duomenis Jums naudojantis Interneto
        svetaine, mūsų administruojamomis socialinėmis paskyromis, Jums
        susisiekus su mumis telefonu ar el. komunikacijos priemonėmis, atvykus į
        mūsų prekių atsiėmimo punktą;
      </p>
      <br />
      <p>
        Taikomų teisės aktų numatyta apimtimi mes taip pat galime gauti
        informaciją apie Jus iš kitų šaltinių, pvz., viešai prieinamų registrų,
        duomenų bazių, rinkodaros partnerių ir kitų trečiųjų šalių.
      </p>
      <br />
      <p>
        Priklausomai nuo Jūsų naudojamo socialinio tinklo nustatymų, jei
        pasirenkate susieti savo socialinio tinklo paskyrą su savo paskyra mūsų
        Interneto svetainėje, mes galėsime matyti tam tikrus duomenis iš Jūsų
        socialinio tinklo paskyros, įskaitant Jūsų asmeninės paskyros duomenis:
        paskyroje nurodomą Jūsų vardą, pavardę ar pseudonimą, profilio nuotrauką
        ir el. pašto adresą.
      </p>
      <br />
      <p>
        Jūs turite teisę keisti ir atnaujinti mums pateiktą savo informaciją.
        Kai kuriais atvejais (pavyzdžiui parduodant Jums prekes, jas pristatant
        ar pan.) mums būtina turėti tikslią ir naujausią su Jumis susijusią
        informaciją, reikalingą kokybiškam paslaugų teikimui, todėl Jūsų galime
        paprašyti periodiškai patvirtinti, kad mūsų turima informacija apie Jus
        yra teisinga.
      </p>
      <br />
      <p>
        Teikdami Asmens duomenis mums, Jūs atsakote už šių Asmens duomenų
        teisingumą, išsamumą, aktualumą. Savo Interneto svetainėje naudojame
        „trečiosios šalies slapukus“, tai yra slapukus, kurių valdytojais nesame
        mes, pvz., Google Analytics, Google Ads, Facebook ir kitus slapukus.
        Šiuos slapukus mes naudojame siekdami gauti statistinę informaciją apie
        internetinės svetainės naudojimą bei Jūsų elgesiu grindžiamos
        internetinės reklamos tikslais.
      </p>
      <br />
      <p>Kas yra slapukas ir koks jo tikslas?</p>
      <br />
      <p>
        Slapukas (angl. Cookie) yra tekstinė informacija, kurią serveris siunčia
        į naršyklę, ir kuri yra saugoma naršyklėje. Ši informacija yra siunčiama
        į serverį kiekvieną kartą, kai naršyklė prašo atidaryti internetinį
        puslapį. Tai leidžia serveriui prisiminti naršyklės nustatymus ar
        stebėti interneto naršyklės apsilankymus.
      </p>
      <br />
      <p>
        Slapukai suteikia galimybę internetinei svetainei veikti efektyviau ir
        pagerinti savo paslaugas, be to, teikti informaciją svetainės
        administratoriams statistikos ar reklamos tikslais. Visų pirma siekiant
        individualizuoti navigacijos patirtį prisimenant jus (pavyzdžiui
        atpažįstant prisijungiant prie savo paskyros, neberodyti jums neaktualių
        reklamos pasiūlymų ir t.t.).
      </p>
      <br />
      <p>
        Daugiau informacijos apie Internetinėje svetainėje naudojamus slapukus
        rasite čia:
      </p>
      <br />
      <div className="w-full overflow-x-auto">
        <table className="w-full table-auto border-separate border-spacing-4 text-left">
          <thead>
            <tr>
              <th>Pavadinimas</th>
              <th>Platforma</th>
              <th>Tikslas</th>
              <th>Sukūrimo momentas</th>
              <th>Galiojimo laikas</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>-</td>
              <td>Google analytics</td>
              <td>
                Vartotojų lankomumo analizė, trečiosios šalies naudotojo elgesiu
                grindžiamos internetinės reklamos tikslais.
              </td>
              <td>Apsilankius interneto svetainėje.</td>
              <td>2 metai, iki naršyklės uždarymo, 1 diena.</td>
            </tr>
            <tr>
              <td>-</td>
              <td>Google analytics</td>
              <td>Vartotojų lankomumo analizė.</td>
              <td>Apsilankius interneto svetainėje.</td>
              <td>2 metai, iki naršyklės uždarymo, 18 mėnesių.</td>
            </tr>
            <tr>
              <td>-</td>
              <td>Facebook</td>
              <td>
                Trečiosios šalies naudotojo elgesiu grindžiamos internetinės
                reklamos tikslais.
              </td>
              <td>Apsilankius interneto svetainėje.</td>
              <td>10 min, 1 metus, 90 dienų, 5 metai, 28 dienos.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h4>III SKYRIUS</h4>
      <br />
      <h4>BAIGIAMOSIOS NUOSTATOS</h4>
      <br />
      <p>
        Šios Taisyklės peržiūrimos ir atnaujinamos pasikeitus teisės aktams,
        kurie reglamentuoja asmens duomenų tvarkymą.
      </p>
      <br />
      <p>
        Darbuotojai ir kiti atsakingi asmenys su šiomis Taisyklėmis yra
        supažindinami pasirašytinai arba elektroninėmis priemonėmis ir privalo
        laikytis joje nustatytų įpareigojimų bei atlikdami savo darbo funkcijas
        vadovautis šiose Taisyklėse nustatytais principais. Klientui paprašius
        jiems yra suteikiama galimybė susipažinti su šiomis Taisyklėmis.
      </p>
      <br />
      <p>
        Įmonė turi teisę iš dalies arba visiškai pakeisti šias Taisykles. Su
        pakeitimais darbuotojai ir kiti atsakingi asmenys yra supažindinami
        pasirašytinai arba elektroninėmis priemonėmis
      </p>
      <br />
      <p>
        Jei turite klausimų, susisiekite <a href="">info@telomera.lt</a>
      </p>
      <br />
    </div>
  );
};

export default CookiesPolicys;
